import { AubadeComponent } from "js/front/bootstrap/AubadeComponent";
import gsap from "gsap";

class Header extends AubadeComponent {
    constructor(e, b) {
        super(e, b);

        this.buttonMenu = this.element.querySelectorAll(".button-menu");
        this.background = this.element.querySelector("#header-bg-opacity");
        this.headerHome = this.element.querySelector(".header-home");
        this.headerNotHome = this.element.querySelector(".header-not-home");
        this.backButton = this.element.querySelector("#button-retour");

        this.onClickButtonMenu = this.onClickButtonMenu.bind(this);
        this.onClickClose = this.onClickClose.bind(this);
        this.hideHeader = this.hideHeader.bind(this);

        this.openHeaderHome = this.openHeaderHome.bind(this);
        this.openHeaderNotHome = this.openHeaderNotHome.bind(this);
        this.toggleOnSimulateur = this.toggleOnSimulateur.bind(this);
    }

    attach() {
        this.buttonMenu.forEach(element => {
            element.addEventListener("click", this.onClickButtonMenu);
        });
        if (this.buttonCloseHeader)
            this.buttonCloseHeader.addEventListener("click", this.onClickClose);
    }

    detach() {
        this.buttonMenu.removeEventListener("click", this.onClickButtonMenu);
        if (this.buttonCloseHeader)
            this.buttonCloseHeader.removeEventListener(
                "click",
                this.onClickClose
            );
    }

    showButtonMenu() {
        return gsap.to(this.buttonMenu, {
            y: 0,
            ease: "power3.out",
            duration: 0.6
        });
    }

    hideButtonMenu() {
        return gsap.to(this.buttonMenu, {
            y: -50,
            ease: "power3.in",
            duration: 0.4
        });
    }

    hideHeader() {
        if (this.headerNotHome.classList.contains("active"))
            this.headerNotHome.classList.remove("active");
        if (this.headerHome.classList.contains("active"))
            this.headerHome.classList.remove("active");
    }

    openHeaderHome() {
        const tl = gsap.timeline();

        tl.add(() => {
            if (this.headerNotHome.classList.contains("active"))
                this.headerNotHome.classList.remove("active");
        });

        tl.add(() => {
            if (!this.headerHome.classList.contains("active"))
                this.headerHome.classList.add("active");
        }, 1);
    }

    toggleOnSimulateur() {
        this.headerNotHome.classList.toggle("simulateur");
    }

    openHeaderNotHome() {
        const tl = gsap.timeline();

        tl.add(() => {
            if (this.headerHome.classList.contains("active"))
                this.headerHome.classList.remove("active");
        });

        tl.add(() => {
            if (!this.headerNotHome.classList.contains("active"))
                this.headerNotHome.classList.add("active");
        }, 1);
        const buttonBackRef = document.querySelector("#button-back");
        if (buttonBackRef) this.backButton.href = buttonBackRef.href;
    }

    onClickButtonMenu() {
        const tl = gsap.timeline();

        this.background.style.display = "block";

        tl.add(this.hideButtonMenu(), 0);
        tl.fromTo(
            this.background,
            { opacity: 0 },
            { opacity: 1, ease: "none", duration: 0.4 },
            0
        );
        tl.add(() => {
            window.eaOpenHeader();

            this.buttonCloseHeader = document.querySelector(
                "#fps-header .close"
            );
            this.buttonCloseHeader.addEventListener("click", this.onClickClose);
        });

        return tl;
    }

    onClickClose() {
        const tl = gsap.timeline();

        tl.add(this.showButtonMenu(), 0.4);
        tl.to(this.background, { opacity: 0, ease: "none", duration: 0.4 }, 0);
        tl.add(() => {
            this.background.style.display = "none";
        });

        return tl;
    }
}

export { Header };
